import {
    SAVE_BOOKING_DETAILS,
    RESET_BOOKING_DETAILS,
    SAVE_ALL_MEAL_PLANS,
    RESET_ALL_MEAL_PLANS,
    SAVE_ALL_RECEIPTS,
    RESET_ALL_RECEIPTS_DATA
} from "../types";

const INITIAL_STATE = {
    bookingDetails: {},
    mealPlans: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 10,
    },
    receipts : {
        list: [],
    },
};

const bookingReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case SAVE_BOOKING_DETAILS:
            return {
                ...state,
                bookingDetails: payload
            };

        case RESET_BOOKING_DETAILS:
            return {
                ...state,
                bookingDetails: INITIAL_STATE.bookingDetails,
            };

        case SAVE_ALL_MEAL_PLANS:
            return {
                ...state,
                mealPlans: {
                    pageSize: 10,
                    ...payload,
                },
            };

        case RESET_ALL_MEAL_PLANS:
            return {
                ...state,
                mealPlans: INITIAL_STATE.mealPlans,
            };

        case SAVE_ALL_RECEIPTS:
            return {
                ...state,
                receipts: payload,
            };

        case RESET_ALL_RECEIPTS_DATA:
            return {
                ...state,
                receipts: INITIAL_STATE.receipts,
            };

        default:
            return state;
    }
};

export default bookingReducer;
